import React, {useEffect, useState} from 'react';
import CustomTable, {TypeItemTable} from "../../../components/general/CustomTable";
import {useTranslation} from "react-i18next";
import {SimulatorMock} from "../../../test/mock/SimulatorMock";

interface Props {}
export default function Simulator({}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()

    useEffect(() => {
        if (SimulatorMock) {
            setListElement(SimulatorMock.map(item =>
                ({row: [item.time, <div className={'text-end pr-2'}>{`$${item.value}`}</div>]}))
            )
        }
    }, [SimulatorMock]);

    return(
        <CustomTable
            header={[
                t('time'),
                t('value'),
            ]}
            pagination={false}
            {...{listElement}}
        />
    )
}
